<template>
    <div class="drag-verify">
        <div class="drag-verify-track">
            <div class="drag-verify-handler" :style="{ left: handlerLeft + 'px' }" @mousedown="startDrag">
                <i class="el-icon-d-arrow-right"></i>
            </div>
            <div class="drag-verify-text">
                {{ isPassing ? '验证通过' : '请按住滑块拖动' }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DragVerify',
        data() {
            return {
                handlerLeft: 0, // 滑块的左侧偏移量
                isDragging: false, // 是否正在拖动
                isPassing: false, // 是否验证通过
            };
        },
        methods: {
            // 开始拖动
            startDrag() {
                if (this.isPassing) {
                    return;
                }
                this.isDragging = true;
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.stopDrag);
            },
            // 处理拖动
            handleDrag(event) {
                if (this.isDragging) {
                    const trackWidth = this.$el.querySelector('.drag-verify-track').offsetWidth;
                    const handlerWidth = this.$el.querySelector('.drag-verify-handler').offsetWidth;
                    const maxLeft = trackWidth - handlerWidth;

                    // 计算滑块的左侧偏移量
                    this.handlerLeft = Math.min(Math.max(event.clientX - this.$el.getBoundingClientRect().left -
                        handlerWidth / 2, 0), maxLeft);

                    // 如果滑块拖动到最右侧，验证通过
                    if (this.handlerLeft >= maxLeft - 5) {
                        this.isPassing = true;
                        this.$emit('pass');
                    }
                }
            },
            // 停止拖动
            stopDrag() {
                this.isDragging = false;
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.stopDrag);

                // 如果未验证通过，重置滑块位置
                if (!this.isPassing) {
                    this.handlerLeft = 0;
                }
            },
        },
    };
</script>

<style scoped>
    .drag-verify {
        width: 100%;
        margin-bottom: 20px;
    }

    .drag-verify-track {
        position: relative;
        width: 100%;
        height: 40px;
        background-color: #f5f7fa;
        border-radius: 20px;
        overflow: hidden;
    }

    .drag-verify-handler {
        position: absolute;
        top: 0;
        left: 0;
        width: 40px;
        height: 40px;
        background-color: #409eff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .drag-verify-handler i {
        color: white;
        font-size: 16px;
    }

    .drag-verify-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;
        color: #606266;
        user-select: none;
    }

    .drag-verify-handler:hover {
        background-color: #66b1ff;
    }
</style>